import {
  channelIcons } from '../../pages/Authorization/ResendVerification/icons';
import classNames from 'classnames';
import { Checkbox } from 'components/InteractiveUIControls/Checkbox/Checkbox';
import { type Dispatch, type FC, type SetStateAction } from 'react';
import { VerificationChannel } from 'types';

type Props = {
  activeType: VerificationChannel,
  enabled: boolean,
  methodSelected: Map<boolean, VerificationChannel> | null,
  setMethodSelected: Dispatch<SetStateAction<Map<boolean, VerificationChannel> | null>>,
  type: VerificationChannel,
};

const getTextType = (type: VerificationChannel) => {
  const { Email,
    Sms,
    WhatsApp } = VerificationChannel;
  if (type === Email) {
    return 'Email';
  }

  if (type === Sms) {
    return 'SMS';
  }

  if (type === WhatsApp) {
    return 'WhatsApp';
  }

  return '';
};

export const LoginVerificationMethod: FC<Props> = ({ activeType,
  enabled,
  methodSelected,
  setMethodSelected,
  type }) => {
  const IconComponent = channelIcons[type];
  const textType = getTextType(type);
  const isActive = type === activeType;
  const text = isActive ?
    `Resend code by ${textType}` : textType;
  const selected = methodSelected?.get(true) === type;

  const handleMethodClick = () => {
    if (!enabled) {
      return;
    }

    const newMap = new Map<boolean, VerificationChannel>();
    newMap.set(true, type);
    setMethodSelected(newMap);
  };

  return (
    <div
      className={classNames('flex h-11 items-center justify-between rounded-main border border-black-200 bg-transparent p-[0.5rem]', {'border-label-g-300': selected})}
      onClick={() => handleMethodClick()}
    >
      <div className='flex items-center gap-[0.5rem]'>
        <Checkbox
          checkboxClassName='!rounded-[50%] !size-[1rem]'
          data-test={`${type}-${selected ? 'checked' : 'unchecked'}`}
          disabled={!enabled}
          intermediate
          isGreen
          selected={selected}
        />
        {
          IconComponent && <div className={classNames({'opacity-50': !enabled})}><IconComponent /></div>
        }
        <div className={classNames('text-font-1 font-medium', {'opacity-50': !enabled})}>{text}</div>
      </div>
      {enabled ? null : <div className='flex h-[1.375rem] w-[6.4375rem] items-center justify-center rounded-main border border-black-300 bg-black-150 px-[0.5rem] py-[0.125rem] text-font-3'>Not available</div>}
    </div>
  );
};
